import { EventEmitter, Output } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { SearchAgGrid } from '../bodisplay';
import { BObjectModel, CustomgridModel, CustomgridParam, CustomgridSQL, CustomgridXml, ModeBo, QueovalItem, Select } from '../models';
import { HttpService, CoreService } from '../services';

@Component({
  selector: 'q-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  //#region required Inputs
  public idBo: string = '';

  public idPere: string = '';

  public codeRelation: string = '';
  //#endregion
  public multiBo: boolean = true;

  public selectSingle: boolean = false;

  public where: string = '';

  public modelLink: SearchAgGrid;

  public initBo: boolean = false;
  public filtre: string = '';
  public modeBo = ModeBo;

  public onlyReattached: boolean = false;
  public origin: string = '';
  public reattachedName: string = '';

  public loadDataGrid: boolean = false;

  public customgridParam: CustomgridModel;

  public model: BObjectModel;
  public saveBo: boolean = false;

  public BOs: Array<QueovalItem> = [];
  public displayGrid: boolean = false;

  private idBoOnInit: string = '';

  public Idents: string[]; 
  //#region required Inputs
  @Input('idBo') set SetIdBo(value: string) {
    this.idBoOnInit = value;
    this.idBo = value;
  }

  @Input('idPere') set SetIdPere(value: string) {
    this.idPere = value;
  }

  @Input('codeRelation') set SetCodeRelation(value: string) {
    this.codeRelation = value;
  }
  //#endregion

  //#region Optionnal Inputs
  @Input('multiBo') set SetMultiBo(value: boolean) {
    this.multiBo = value;
  }

  @Input('where') set SetWhere(value: string) {
    this.where = value;
  }

  // Si non renseigné on prendra celui construit dans la méthode OnSave()
  @Input('modelForLink') set SetModel(value: SearchAgGrid) {
    this.modelLink = value;
  }

  @Input('selectSingle') set SetSelectSingle(value: boolean) {
    this.selectSingle = value;
  }
  
  //#endregion

  @Output() success: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sendListIdent: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
  @Output() sendListIdentValue: EventEmitter<Array<Select>> = new EventEmitter<Array<Select>>();
  constructor(
    public http: HttpService,
    public indParam: CoreService,
    public cd: ChangeDetectorRef,
  ) {
  }


  public ngOnInit(): void {

    this.http.getHttp<SearchAgGrid>(`${this.indParam.AppParams.apiUrl}api/SearchAgGrid/GET_BO_LIST/${this.idBo}`).subscribe
      ((result: SearchAgGrid) => {
        this.BOs = result.boList;
      });
    if (this.codeRelation) {
      this.http.getHttp<SearchAgGrid>(`${this.indParam.AppParams.apiUrl}api/SearchAgGrid/GET_TITRE_RELATION/${this.codeRelation}|${this.idBo}`).subscribe
        ((result: SearchAgGrid) => {
          this.reattachedName = result.reattachedName;
          this.origin = result.Origin;
        });
    }

    this.model = new BObjectModel();
    this.model.IdRelation = this.codeRelation;
    this.model.IdentBO = this.idBo;
    this.model.IdDonneePere = '0';
    this.model.IdDonneeFils = '0';
    this.initBo = true;
  }

  public Search() {
    this.saveBo = true;
    this.loadDataGrid = true;
    this.displayGrid = false;
    this.cd.detectChanges();
  }

  public OnSelectionChanged(event: SelectionChangedEvent): void {
    // this.gridApi = agGrid;
    const selectedRows = event.api.getSelectedRows();    
    if (selectedRows && selectedRows.length > 0) {
      this.Idents = selectedRows.map(row => { return row["Ident"] });
      
    } else {
      this.Idents = [];      
    }
  }

  public OnSave() {
    let model: SearchAgGrid = new SearchAgGrid();
    if (!this.modelLink) {
      model.Mode = 'LINK';
      model.CodeRelation = this.codeRelation;
      model.IdDonnee = this.idPere;
      model.Origin = 'FILS';
    } else {
      model = this.modelLink;
    }
    model.Idents = this.Idents;

    this.http.postHttp<SearchAgGrid>(`${this.indParam.AppParams.apiUrl}api/SearchAgGrid/`, model).subscribe
      ((result: SearchAgGrid) => {
        if ((!result.HasError)) {          
          if (model.ColumnNameToDisplay && model.ColumnNameToDisplay != '') {
            this.sendListIdentValue.emit(result.IdentsValues);
          }
          else if (this.Idents.length > 0) {
            this.sendListIdent.emit(this.Idents);
          }
          this.success.emit(true);
        }
      });
  }

  /**
  * Récuperation du filtre BoFind
  */
  public GetWhere(e: any): void {
    if (e) {
      this.filtre = e;
    } else {
      this.filtre = '';
    }

    const model: SearchAgGrid = new SearchAgGrid();
    model.Mode = 'GET_GRID';
    model.IdBo = this.idBo == 'ALL' ? this.idBoOnInit : this.idBo;
    model.Code = this.idBo;
    model.Origin = this.origin;
    if (!this.where)
      model.Where = this.filtre;
    else {
      if (!this.where.replace(' ', '').toUpperCase().startsWith('AND')) {
        model.Where = 'AND ';
      }
      model.Where += `${this.where} ${this.filtre}`;
    }
    model.GridName = `PAGE_RECHERCHE_${this.idBoOnInit}_${this.codeRelation}`
    model.IdDonnee = this.onlyReattached ? this.idPere : '';
    this.http.postHttp<SearchAgGrid>(`${this.indParam.AppParams.apiUrl}api/SearchAgGrid/`, model).subscribe
      ((result: SearchAgGrid) => {

        this.customgridParam = new CustomgridModel();
        this.customgridParam.GridXml = new CustomgridXml();
        this.customgridParam.GridXml.rowData = new CustomgridSQL();
        this.customgridParam.cgParameters = new CustomgridParam();
        this.customgridParam.cgParameters.FileName = `PAGE_RECHERCHE_${this.idBoOnInit}_${this.codeRelation}`;
        this.customgridParam.GridXml.columnDefs = result.columnDefs;
        this.customgridParam.GridXml.rowData.data = JSON.stringify(result.rowData);
        this.customgridParam.GridXml.rowSelection = this.selectSingle ? 'single' : 'multiple';
        this.customgridParam.GridXml.groupSelectsChildren = this.selectSingle ? false : true;
        this.customgridParam.cgParameters.isDataLoaded = true;
        this.customgridParam.GridXml.pagination = true;
        this.customgridParam.GridXml.paginationAutoPageSize = true;
        setTimeout(() => {
          this.loadDataGrid = false;
        }, 275);
        this.displayGrid = true;
      });
  }

}
